import './body.css'

export const setBodyClass = (embedded) => (
  document.body.classList.add(embedded ? 'app--embedded' : 'app--standalone')
)



// WEBPACK FOOTER //
// ./src/embedded/setBodyClass/index.js